import React, { Component } from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { t } from 'services/translation';

import './index.scss';

class SessionTimeoutError extends Component {
  static mixins = [PureRenderMixin];

  static defaultProps = {
    title: 'Session Expired',
    secondaryMessage: 'Please log in again.',
  };

  buttonClick = () => {
    window.location.reload();
  };

  renderButton = () => {
    return (
      <div className="GlobalError-ButtonContainer">
        <a onClick={this.buttonClick} className="ui button session-timeout">
          Okay
        </a>
      </div>
    );
  };

  getMessage = () => {
    let min_text = 'minute';
    if (parseInt(this.props.timeoutMinutes) > 1) {
      min_text = 'minutes';
    }

    return `${t('SESSION_EXPIRY_TEXT', '', {
      timeoutMinutes: this.props.timeoutMinutes,
      minText: min_text,
    })}`;
  };

  render() {
    return (
      <div className="GlobalError-Container SessionTimeoutError">
        <div className="GlobalError-Message">
          <h1>
            <span className="text">{this.props.title}</span>
          </h1>
          <p>{this.getMessage()}</p>
          <p>{this.props.secondaryMessage}</p>
        </div>
        {this.renderButton()}
      </div>
    );
  }
}

export default SessionTimeoutError;
